import React from 'react';
import { Tag } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';

const UnavailableBadge = () => (
    <Tag size={Tag.SIZES.TINY} color={Tag.COLORS.GREY} kind={Tag.KINDS.HOLLOW}>
        <I18n k="collections_perseus.collection_page.seller_card.unavailable" />
    </Tag>
);

export default UnavailableBadge;
